<template>
  <div v-if="visible" class="red-packet-container">
    <div class="red-packet">
      <div class="red-packet-cover">
        <div class="red-packet-icon">🧧</div>
        <div class="red-packet-text">{{ text }}</div>
      </div>
      <div class="red-packet-ribbon"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RedPacketNotification',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    autoClose: {
      type: Number,
      default: 3000
    },
    text: {
      type: String,
      default: '新红包'
    }
  },
  data() {
    return {
      timer: null
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.startAutoClose()
      } else {
        this.clearTimer()
      }
    }
  },
  methods: {
    startAutoClose() {
      this.clearTimer()
      if (this.autoClose > 0) {
        this.timer = setTimeout(() => {
          this.$emit('update:visible', false)
        }, this.autoClose)
      }
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    }
  },
  beforeDestroy() {
    this.clearTimer()
  }
}
</script>

<style scoped>
/* 容器：居中+更小的尺寸，动效更细腻 */
.red-packet-container {
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  padding: 0 12px;
  animation: fadeInUp 0.4s ease-out forwards;
  pointer-events: none;
}

/* 红包主体：缩小尺寸，优化圆角和阴影质感 */
.red-packet {
  position: relative;
  width: 160px;   /* 原280px → 160px */
  height: 80px;   /* 原120px → 80px */
  background: linear-gradient(135deg, #ff5252, #e53935);
  border-radius: 12px; /* 更精致的圆角 */
  box-shadow: 0 4px 16px rgba(255, 82, 82, 0.25); /* 更柔和的阴影 */
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.red-packet-cover {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

/* 图标缩小，动效更轻盈 */
.red-packet-icon {
  font-size: 24px; /* 原36px → 24px */
  margin-bottom: 4px; /* 原8px → 4px */
  animation: bounce 1.2s infinite ease-in-out; /* 更快的弹跳频率 */
}

/* 文字更小更精致 */
.red-packet-text {
  color: #fff;
  font-size: 14px; /* 原16px → 14px */
  font-weight: 500; /* 原600 → 500，更柔和 */
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 飘带缩小，动效更细腻 */
.red-packet-ribbon {
  position: absolute;
  top: -6px;    /* 原-10px → -6px */
  right: -6px;  /* 原-10px → -6px */
  width: 30px;  /* 原60px → 30px */
  height: 30px; /* 原60px → 30px */
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  filter: blur(6px); /* 原10px → 6px */
  animation: float 2.5s infinite ease-in-out;
}

.red-packet-ribbon::after {
  content: '';
  position: absolute;
  top: 10px;   /* 原20px → 10px */
  left: 10px;  /* 原20px → 10px */
  width: 20px; /* 原40px → 20px */
  height: 20px;/* 原40px → 20px */
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  filter: blur(4px); /* 原8px → 4px */
  animation: float 2s infinite ease-in-out 0.5s;
}

/* 入场动画更细腻 */
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate(-50%, 20px); /* 原50px → 20px，更短的位移 */
  }
  100% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

/* 弹跳动效更轻微 */
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px); /* 原-8px → -4px，更轻微的弹跳 */
  }
}

/* 飘带动效更柔和 */
@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(-3px, -4px) scale(1.05); /* 原-5px/-8px → -3px/-4px，缩放更轻微 */
  }
}

/* 退场动画同步优化 */
.red-packet-container-leave-active {
  animation: fadeOutDown 0.3s ease-in forwards;
}

@keyframes fadeOutDown {
  0% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, 20px); /* 原50px → 20px */
  }
}
</style>